module.exports = __webpack_public_path__ + "img/unfillcertificate.1a606dca.jpg";